/* Search long lists of filter choices without submitting the product filter form. */
if (!customElements.get('facet-value-search')) {
  customElements.define('facet-value-search', class extends HTMLElement {
    connectedCallback() {
      if (!this.initialized) {
        this.input = this.querySelector('[data-facet-search]');
        this.emptyMessage = this.querySelector('.tcg-facet-search__empty');
        if (!this.input || !this.emptyMessage) return;
        this.initialized = true;
        this.input.addEventListener('input', (event) => {
          event.stopPropagation();
          this.filterOptions();
        });
        this.input.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') event.preventDefault();
        });
      }
      this.observer?.disconnect();
      // Shopify replaces the list while preserving this search field after a selection.
      this.observer = new MutationObserver(() => this.filterOptions());
      this.observer.observe(this.parentElement, { childList: true });
      this.filterOptions();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    filterOptions() {
      const enteredQuery = this.input.value.trim();
      const query = enteredQuery.toLocaleLowerCase();
      const items = this.parentElement.querySelectorAll('.mobile-facets__item');
      let matches = 0;
      items.forEach((item) => {
        const label = item.querySelector('.facet-checkbox__text-label')?.textContent || '';
        item.hidden = !label.toLocaleLowerCase().includes(query);
        if (!item.hidden) matches += 1;
      });
      this.emptyMessage.textContent = this.emptyMessage.dataset.emptyTemplate.replaceAll('__QUERY__', () => enteredQuery);
      this.emptyMessage.hidden = matches > 0;
    }
  });
}
